import styled, { css } from 'styled-components/macro';

export const MobileHiddenSpan = styled.span`
  @media screen and (max-width: 767px) {
    display: none;
  }
`;

export const MobileOnlySpan = styled.span`
  @media screen and (min-width: 768px) {
    display: none;
  }
`;

export const TabletOnlySpan = styled.span`
  @media screen and (max-width: 767px) {
    display: none;
  }
  @media screen and (min-width: 1024px) {
    display: none;
  }
`;

export const DesktopOnlySpan = styled.span`
  @media screen and (max-width: 1023px) {
    display: none;
  }
`;

export const ContentLargeOnlySpan = styled.span`
  ${props =>
    props.theme.sidebarOpened
      ? css`
          @media screen and (max-width: 1223px) {
            display: none;
          }
        `
      : css`
          @media screen and (max-width: 1023px) {
            display: none;
          }
        `}
`;
